<template>
  <div class="TestFunctions ">

    <button type="button" class="btn btn-primary btn-sm" v-on:click="doFn">
      <i class="fa fa-ban"></i> {{$t('global.do')}}
    </button>


  </div>
</template>

<script>
  import Api from '@/api/Api';
  import moment from 'moment';

  export default {
    name: 'TestFunctions',
    data(){
      return {
        valami: ""
        , state: {}
      }
    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);

//      if (typeof delay !== "undefined") {
//        this.delayData = delay;
//      }
    },
    props: {
//      type: String, // primary secondary success danger warning info light dark
//      msg: String,
//      msgPre: {
//        type: String,
//        default: "",
//      },
//      msgPost: {
//        type: String,
//        default: "",
//      },
//      delay: Number,
    },
    watch: {
      msg: function (newmsg, oldmsg) {
        const modul = this;
      },
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

    },
    methods: {
      doFn(e){
        console.log("doFn - run");
        const modul = this;
        const oData = {
          id: "-",
          id_company: modul.state.id_company,
          data: {
//            dateFrom: moment().add(-5, 'day').format('YYYY-MM-DD'),
//            dateTo: moment().add(-4, 'day').format('YYYY-MM-DD')
          }
        };

        Api.doTest(oData).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
//            console.log(res);
          }
          console.log(res);
        }, function (err) {
          console.log(err);
        });

      },
    }

  };
</script>

<style scoped="">


</style>


